import premiumComponent from './Component/Component';
import datasource from './DataSource/DataSource';
import sketchpad from './Sketchpad/Sketchpad';
import tagpad from './Tagpad/Tagpad';
import dynamicWizard from './DynamicWizard/DynamicWizard';
import datatable from './DataTable/DataTable';
import reviewPage from './ReviewPage/ReviewPage';
import premiumSignature from './PremiumSignature/PremiumSignature';
import captcha from './Captcha/Captcha';
export default {
    component: premiumComponent,
    base: premiumComponent,
    signature: premiumSignature,
    datasource: datasource,
    sketchpad: sketchpad,
    tagpad: tagpad,
    dynamicWizard: dynamicWizard,
    datatable: datatable,
    reviewpage: reviewPage,
    captcha: captcha
};
